import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b3c72d2a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b3c72d2a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c72d2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3c72d2a')) {
      api.createRecord('b3c72d2a', component.options)
    } else {
      api.reload('b3c72d2a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b3c72d2a&scoped=true", function () {
      api.rerender('b3c72d2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/abnormalOrders/collectPending/index.vue"
export default component.exports